import { useStoreState } from '@ariakit/react'
import { ComponentProps, forwardRef } from 'react'

import { DropdownButton, Menu } from '@syconium/little-miss-figgy'

import { useCollectionFilterQueryParamsContext } from '../../../../../../../../brunswick/containers/CollectionFilterQueryParamsContext'
import { FilterList } from '../../../../../../../../components/atoms/FilterList'
import { useCollectionFiltersContext } from '../../containers/CollectionFiltersContext'

import * as Styles from './styles'

/** Individual filter buttons for the desktop filter menubar. */
const FilterButton = forwardRef<HTMLButtonElement, Partial<ComponentProps<typeof DropdownButton>>>(
  function FilterButton({ children, ...rest }, ref) {
    const menuContext = Menu.useMenuContext()
    const menuState = useStoreState(menuContext)
    const active = menuState?.open ?? false

    return (
      <DropdownButton ref={ref} active={active} {...rest}>
        {children}
      </DropdownButton>
    )
  }
)

/** The desktop filter menubar. */
export const DesktopFilterNav = () => {
  const { filters, totalItemsCount } = useCollectionFiltersContext()
  const { totalNumberOfSelectedFilterValues } = useCollectionFilterQueryParamsContext()

  return (
    <Styles.Body>
      <Styles.Menubar>
        {filters?.map(filter => (
          <Menu.Provider key={filter.key}>
            <Menu.MenubarButton render={<FilterButton />}>{filter.displayName}</Menu.MenubarButton>
            <Menu.Menu>
              <FilterList.List count={filter.filterValues?.length ?? 0}>
                {filter?.filterValues?.map(filterValue => (
                  <Menu.MenuItem
                    key={filterValue.value}
                    hideOnClick={false}
                    render={
                      filter.displayType === 'basicColor' ? (
                        <FilterList.ColorItem
                          filterKey={filter.key}
                          filterValue={filterValue}
                          asLink={filter.crawlable && totalNumberOfSelectedFilterValues === 0}
                        />
                      ) : (
                        <FilterList.CheckboxItem
                          filterKey={filter.key}
                          filterValue={filterValue}
                          asLink={filter.crawlable && totalNumberOfSelectedFilterValues === 0}
                        />
                      )
                    }
                  />
                ))}
              </FilterList.List>
            </Menu.Menu>
          </Menu.Provider>
        ))}
      </Styles.Menubar>
      {totalItemsCount && totalItemsCount > 0 ? (
        <Styles.Label>{totalItemsCount} Total</Styles.Label>
      ) : null}
    </Styles.Body>
  )
}
